import { combineReducers } from 'redux';
import { executors } from './redux/reducers/executors';
import { executorCard } from './redux/reducers/executorCard';
import { filters } from './redux/reducers/filters';

export const Executors = combineReducers({
  Filters: filters,
  Executors: executors,
  ExecutorCard: executorCard,
});
